import React from 'react';
import Translate from '@spordle/intl-elements';
import { ArrowDown } from 'react-feather';

export const TeamGameViewButton = ({ buttonText, currentState, nextState }) => {
  const onClick = () => {
    nextState();
    scrollTo();
  }

  const scrollTo = () => {
    const view = document.querySelector(".team-filters");
    if (!view) return;
    view.scrollIntoView();
  }

  return <div className="team-game-view-container" style={{ textAlign: "center", paddingBottom: "50px" }}>
    <button className="btn btn-link" onClick={onClick} hidden={currentState === 'all'}>
      <Translate id={buttonText} />
      <ArrowDown />
    </button>
  </div>
}
